import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import SmartImg from "./SmartImg";

export default function ImageGallery({ images = [], alt = "" }) {
  const list = images.filter(Boolean);
  const [idx, setIdx] = useState(0);
  if (list.length === 0) return null;

  const active = list[idx] || list[0];
  const prev = () => setIdx((i) => (i - 1 + list.length) % list.length);
  const next = () => setIdx((i) => (i + 1) % list.length);

  return (
    <div className="w-full" data-testid="image-gallery">
      <div className="relative rounded-2xl overflow-hidden border border-neutral-200 aspect-[4/3] group">
        <SmartImg
          key={active}
          src={active}
          alt={alt}
          className="h-full w-full"
          testId="gallery-active-image"
          loading="eager"
        />

        {list.length > 1 && (
          <>
            <button
              type="button"
              onClick={prev}
              aria-label="Previous image"
              className="absolute left-3 top-1/2 -translate-y-1/2 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/90 backdrop-blur-sm border border-neutral-200 shadow-sm hover:bg-white transition-colors opacity-0 group-hover:opacity-100 focus:opacity-100"
              data-testid="gallery-prev"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              type="button"
              onClick={next}
              aria-label="Next image"
              className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/90 backdrop-blur-sm border border-neutral-200 shadow-sm hover:bg-white transition-colors opacity-0 group-hover:opacity-100 focus:opacity-100"
              data-testid="gallery-next"
            >
              <ChevronRight size={18} />
            </button>
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 inline-flex gap-1.5">
              {list.map((_, i) => (
                <span
                  key={i}
                  className={`h-1.5 rounded-full transition-all duration-200 ${
                    i === idx ? "w-6 bg-neutral-900" : "w-1.5 bg-white/80 border border-neutral-300"
                  }`}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {list.length > 1 && (
        <div className="mt-3 grid grid-cols-4 gap-2" data-testid="gallery-thumbnails">
          {list.map((src, i) => (
            <button
              key={src}
              type="button"
              onClick={() => setIdx(i)}
              className={`relative aspect-square rounded-lg overflow-hidden border transition-colors ${
                i === idx
                  ? "border-neutral-900 ring-2 ring-neutral-900/10"
                  : "border-neutral-200 hover:border-neutral-400"
              }`}
              data-testid={`gallery-thumb-${i}`}
              aria-label={`View image ${i + 1}`}
            >
              <SmartImg src={src} alt="" className="h-full w-full" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
